<!-- Tous les services de PromoDeep, puis catégories, réseaux, applications et pages légales -->
<div class="services">
  <h2 class="services-title">{{ 'mobileHome.sectionDeals' | t }}</h2>
  <div class="services-grid">
    @for (tile of dealTiles; track tile.labelKey) {
      <a class="service-tile" [routerLink]="tile.link" [queryParams]="tile.queryParams">
        <span class="service-icon" [ngClass]="'tone-' + tile.tone"><mat-icon>{{ tile.icon }}</mat-icon></span>
        <span class="service-label">{{ tile.labelKey | t }}</span>
      </a>
    }
  </div>

  <h2 class="services-title">{{ 'mobileHome.sectionCommunity' | t }}</h2>
  <div class="services-grid">
    @for (tile of communityTiles; track tile.labelKey) {
      <a class="service-tile" [routerLink]="tile.link" [queryParams]="tile.queryParams">
        <span class="service-icon" [ngClass]="'tone-' + tile.tone"><mat-icon>{{ tile.icon }}</mat-icon></span>
        <span class="service-label">{{ tile.labelKey | t }}</span>
      </a>
    }
  </div>

  <h2 class="services-title">{{ 'mobileHome.sectionInfo' | t }}</h2>
  <div class="services-list">
    <a class="service-row" routerLink="/settings/notifications">
      <mat-icon>notifications_none</mat-icon>
      <span>{{ 'settings.sections.notifications' | t }}</span>
      <mat-icon class="service-row-chevron">chevron_right</mat-icon>
    </a>
    <button type="button" class="service-row" (click)="openNewsletter()">
      <mat-icon>mail_outline</mat-icon>
      <span>{{ 'mobileHome.newsletter' | t }}</span>
      <mat-icon class="service-row-chevron">chevron_right</mat-icon>
    </button>
    <a class="service-row" routerLink="/settings/preferences">
      <mat-icon>translate</mat-icon>
      <span>{{ 'settings.sections.preferences' | t }}</span>
      <mat-icon class="service-row-chevron">chevron_right</mat-icon>
    </a>
  </div>
</div>

<mat-accordion>
  <mat-expansion-panel [expanded]="true" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <b>{{ 'header.categories' | t }}</b>
      </mat-panel-title>
    </mat-expansion-panel-header>


    <a class="dropdown-item mat-cell" routerLink="/pres-de-moi"><mat-icon>near_me</mat-icon>{{ 'nearby.nav' | t }}</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell"
      (click)="onFilterCategory('electro')"><mat-icon>desktop_windows</mat-icon>{{ 'categories.electro' | t }}</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell"
      (click)="onFilterCategory('videoGame')"><mat-icon>videogame_asset</mat-icon>{{ 'categories.videoGame' | t }}</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell" (click)="onFilterCategory('fashion')"><mat-icon> local_mall</mat-icon>{{ 'categories.fashion' | t }}</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell" (click)="onFilterCategory('cosmetic')"><mat-icon>spa</mat-icon>{{ 'categories.cosmetic' | t }}</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell" (click)="onFilterCategory('sport')"><mat-icon>fitness_center</mat-icon>{{ 'categories.sport' | t }}</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell" (click)="onFilterCategory('family')"><mat-icon>child_friendly</mat-icon>{{ 'categories.family' | t }}</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell" (click)="onFilterCategory('home')"><mat-icon>event_seat</mat-icon>{{ 'categories.home' | t }}</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell" (click)="onFilterCategory('animal')"><mat-icon>
        pets</mat-icon>{{ 'categories.animal' | t }}</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell"
      (click)="onFilterCategory('trip')"><mat-icon>airplanemode_active</mat-icon>{{ 'categories.trip' | t }}</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell" (click)="onFilterCategory('mechanic')"><mat-icon>
        directions_car</mat-icon>{{ 'categories.mechanic' | t }}</a>
    <hr class="dropdown-divider">
    <!-- <a class="dropdown-item mat-cell" (click)="onFilterCategory('gardenDIY')"><mat-icon>build</mat-icon>Jardin & Bricolage</a>
    <hr class="dropdown-divider"> -->
    <!-- <a class="dropdown-item mat-cell" (click)="onFilterCategory('service')"><mat-icon>room_service</mat-icon>Services</a>
    <hr class="dropdown-divider"> -->
    <!-- <a class="dropdown-item mat-cell" (click)="onFilterCategory('featuredBrand')"><mat-icon> local_offer</mat-icon>Vedette Brands</a>
    <hr class="dropdown-divider"> -->
    <!-- <a class="dropdown-item mat-cell" (click)="onFilterCategory('training')"><mat-icon>school</mat-icon>Cultures &
      formations</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell" (click)="onFilterCategory('deal')"><mat-icon>settings_phone</mat-icon>Forfaits</a>
    <hr class="dropdown-divider"> -->
    <a class="dropdown-item mat-cell" (click)="onFilterCategory('finance')"><mat-icon>account_balance</mat-icon>{{ 'categories.finance' | t }}</a>
    <!-- <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell" (click)="onFilterCategory('grocery')"><mat-icon>add_shopping_cart</mat-icon>Courses & Épicerie</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell" (click)="onFilterCategory('crypto')"><mat-icon>trending_up</mat-icon>Crypto</a>
    <hr class="dropdown-divider">
    <a class="dropdown-item mat-cell" (click)="onFilterCategory('free')"><mat-icon>card_giftcard</mat-icon>Gratuit</a> -->

  </mat-expansion-panel>
  <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <b>{{ 'footer.joinUs' | t }}</b>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <!-- Pages renseignées dans le back office (Administration → Social networks) -->
    <div class="social-grid">
      @for (link of socialLinks$ | async; track link.network) {
        <ng-template #logo>
          @if (link.svgPath) {
            <svg class="social-icon" viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="link.svgPath"></path></svg>
          } @else {
            <i [class]="link.iconClass" aria-hidden="true"></i>
          }
        </ng-template>
        @if (link.url) {
          <a class="social-link" [href]="link.url" [attr.target]="link.network === 'email' ? null : '_blank'" rel="noopener noreferrer"
            [attr.aria-label]="link.label || ('footer.socialEmail' | t)" [title]="link.label || ('footer.socialEmail' | t)">
            <ng-container [ngTemplateOutlet]="logo"></ng-container>
          </a>
        } @else {
          <!-- Adresse pas encore renseignée dans le back office -->
          <span class="social-link" [title]="link.label || ('footer.socialEmail' | t)">
            <ng-container [ngTemplateOutlet]="logo"></ng-container>
          </span>
        }
      }
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <b>{{ 'footer.ourApps' | t }}</b>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <a href="https://play.google.com/store/apps/details?id=com.promodeep.twa" target="_blank"
        rel="noopener noreferrer" aria-label="android">
        <p class="pi pi-android"></p>
        <span> Android</span>
      </a>
    </div>
    <div>
      <a href="https://apps.apple.com/app/promodeep/id6448401465" target="_blank" rel="noopener noreferrer"
        aria-label="IOS">
        <p class="pi pi-apple"></p>
        <span> IOS</span>
      </a>
    </div>


  </mat-expansion-panel>
  <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <b>{{ 'footer.legal' | t }}</b>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <a class="a-padding" routerLink="/legalNotice">{{ 'footer.legalNotice' | t }}</a>
    </div>
    <hr class="dropdown-divider">
    <div>
      <a class="a-padding" routerLink="/privacyPolicy">{{ 'footer.privacyPolicy' | t }}</a>
    </div>
    <hr class="dropdown-divider">
    <div>
      <a class="a-padding" routerLink="/cookies">{{ 'footer.cookiesPolicy' | t }}</a>
    </div>
    <hr class="dropdown-divider">
    <div>
      <a class="a-padding" href="javascript:void(0)" (click)="showCookieDialog()">{{ 'cookies.manage' | t }}</a>
    </div>
    <hr class="dropdown-divider">
    <div>
      <a class="a-padding" routerLink="/generalPolicy">{{ 'footer.terms' | t }}</a>
    </div>
  </mat-expansion-panel>
</mat-accordion>
